import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { switchMap, take, tap } from 'rxjs/operators';
import { BaseResponse } from '../models/base-response.model';
import { SearchTableParam } from '../models/base-search.model';
import { OrganizationCreate, OrganizationGetAllResponse, OrganizationResponse, OrganizationSearch, OrganizationsListRespone, OrganizationUpdate } from './models/data-models';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {
  private organizationBranchesSubject = new BehaviorSubject<any>(null);
  organizationBranches$: Observable<any> = this.organizationBranchesSubject.asObservable();

  private organizationsSubject = new BehaviorSubject<OrganizationGetAllResponse[]>(null);
  organizations$: Observable<OrganizationGetAllResponse[]> = this.organizationsSubject.asObservable();

  constructor(private http: HttpClient) { }

  public getCoreCompanyBranches() {
    return this.organizationBranches$.pipe(
      take(1),
      switchMap(res => {
        if (res) { return of(res); }
        else { return this.http.get<any>("/EskaCoreIntegrationApi/GetCompanyBranches?companyId=1") }
      }),
      tap(res => res && this.organizationBranchesSubject.next(res.content ? res.content : res))
    )
  }

  public getOrganizations() {
    return this.organizations$.pipe(
      take(1),
      switchMap(res => {
        if (res) { return of(res); }
        else { return this.http.get<OrganizationGetAllResponse[]>(`/OrganizationApi/GetAll`); }
      }),
      tap(res => res && this.organizationsSubject.next(res))
    )
  }

  public create(request: OrganizationCreate|any) {
    return this.http.post<BaseResponse<number>>("/OrganizationApi/Create", request);
  }
  public update(request: OrganizationUpdate |any) {
    return this.http.post<BaseResponse<number>>("/OrganizationApi/Update", request);
  }
  public getList(request: SearchTableParam<OrganizationSearch> |any) {
    return this.http.post<OrganizationsListRespone>("/OrganizationApi/GetList", request);
  }
  public getCategories() {
    return this.http.get<BaseResponse<any>>("/Categories/GetCategoriesByTypeId/2");
  }
  public getCoreCompanies() {
    return this.http.get<BaseResponse<any>>("/EskaCoreIntegrationApi/GetAllCompanies");
  }
  public getAddresses() {
    return this.http.get<BaseResponse<any>>("/UserAdress/GetAllAddresses");
  }
  public get(id: number) {
    return this.http.get<BaseResponse<OrganizationResponse>>(`/OrganizationApi/GetById?Id=${id}`);
  }
  public delete(id: number) {
    return this.http.get<BaseResponse<number>>(`/OrganizationApi/Delete?Id=${id}`);
  }
  public getAll() {
    return this.http.get<OrganizationGetAllResponse[]>(`/OrganizationApi/GetAll`);
  }
}
